import formatMetricValue from '../../helpers/formatMetricValue';
import { SalesRatioFigure, SalesRatioMuted, SalesRatioRoot } from './styled';

export interface SalesRatioValueProps {
    wins: number;
    lost: number;
    labels?: {
        won?: string;
        closed?: string;
    }
}

const SalesRatioValue = ({ wins, lost, labels }: SalesRatioValueProps) => {
    const closed = wins + lost;
    return (
        <SalesRatioRoot>
            <SalesRatioFigure>{formatMetricValue(wins, 'integer')}</SalesRatioFigure>
            <SalesRatioMuted>{labels?.won || 'won'}</SalesRatioMuted>
            <SalesRatioMuted>/</SalesRatioMuted>
            <SalesRatioFigure>{formatMetricValue(closed, 'integer')}</SalesRatioFigure>
            <SalesRatioMuted>{labels?.closed || 'closed'}</SalesRatioMuted>
        </SalesRatioRoot>
    );
};

export default SalesRatioValue;
